<template>
  <div class="homeBox" v-show="showStatus" style="display: none;">
    <Header :colorType='colorType' :pageType='pageType' class="header"></Header>
    <Aboutbanner class='aboutBanner'></Aboutbanner>
    <div class="content">
      <Abouttable></Abouttable>
      <Culture></Culture>
      <Busnesspartner></Busnesspartner>
      <Relation></Relation>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header'
import Aboutbanner from '@/components/about/banner'
import Abouttable from '@/components/about/table'
import Culture from '@/components/about/culture'
import Busnesspartner from '@/components/about/busnessPartner'
import Relation from '@/components/about/Relation'
import Footer from '@/components/footer/Footer'
export default {
  name: 'Ck',
  data: function () {
    return {
      showStatus: false,
      colorType: '3',
      pageType: 'about'
    }
  },
  components: {
    Header,
    Aboutbanner,
    Abouttable,
    Culture,
    Busnesspartner,
    Relation,
    Footer
  },
  mounted: function () {
    this.showStatus = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}
.header{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}
.aboutBanner{
  margin-top: 120px;
  min-width: 1300px;
}
.content{
  min-width: 1300px;
}
</style>



// WEBPACK FOOTER //
// src/components/About/About.vue